"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledFormInputs = exports.StyledFormFieldMetaInfo = exports.StyledFormFieldFeedbackInfo = exports.StyledFormFieldInformation = exports.StyledWrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const tokens_1 = require("../../../styles/tokens");
const Text_styles_1 = require("../../Text/Text.styles");
const Input_styles_1 = require("../Input/Input.styles");
exports.StyledWrapper = styled_components_1.default.div `
    ${({ as }) => {
    if (as === "fieldset") {
        return `
                    margin: 0;
                    padding: 0;
                    border: none;

                    legend {
                        padding: 0;
                    }
                `;
    }
    return null;
}}
`;
exports.StyledFormFieldInformation = styled_components_1.default.div `
    display: flex;
    justify-content: space-between;
`;
exports.StyledFormFieldFeedbackInfo = styled_components_1.default.div `
    overflow: hidden;
    max-width: 100%;

    ${Text_styles_1.StyledText} {
        max-width: 100%;
    }
`;
exports.StyledFormFieldMetaInfo = styled_components_1.default.div `
    margin-left: ${tokens_1.SIZES[0.5]};
    max-width: 100%;
`;
exports.StyledFormInputs = styled_components_1.default.div `
    ${({ grouped }) => grouped &&
    `
        display: flex;
    `}

    ${Input_styles_1.StyledInputBorder} {
        &::before {
            border-radius: 0;
        }

        &:first-of-type::before {
            border-top-left-radius: ${tokens_1.BORDERS.radius};
            border-bottom-left-radius: ${tokens_1.BORDERS.radius};
        }

        &:last-of-type::before {
            border-top-right-radius: ${tokens_1.BORDERS.radius};
            border-bottom-right-radius: ${tokens_1.BORDERS.radius};
        }
    }
`;
//# sourceMappingURL=FormFieldWrapper.styles.js.map